<template>
  <Select
    :items="notasFiscais"
    :selectedItem="filter.notaFiscal"
    label="Nota fiscal"
    searchPlaceholder="Buscar nota fiscal"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        notaFiscal: {
          id: "",
          name: "",
        },
      },
      notasFiscais: [],
    };
  },
  methods: {
    atualizar(notaFiscal) {
      this.filter.notaFiscal = notaFiscal;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.notaFiscal.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.notaFiscal.id
      });
    },
  },
  mounted() {
    this.$api.get('/processos/notas_fiscais_para_select').then(response => {
      this.notasFiscais = response.data.notas_fiscais.map(notaFiscal => ({
        id: notaFiscal.id,
        name: notaFiscal.numeracao
      }));
      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
      this.$renderFiltroSelect(filtroAplicado, this.notasFiscais, this.filter.notaFiscal);
    });
  },
}
</script>
